import { Theme } from '@mui/material/styles'
export const styles = {
  input: {
    background: (theme: Theme) => theme.palette.common.white,
  },

  transparent: {
    background: 'transparent',
  },
}
